import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';

type PersonalInfo = NonNullable<TranscriptorEncounterResponse['patient_info']>;

export const getFullName = (
  info: PersonalInfo | null | undefined,
): string | null => {
  if (!info) {
    return null;
  }

  const trimmed = info.full_name?.trim();

  if (trimmed) {
    return trimmed;
  }

  const composed = [info.first_name, info.last_name]
    .map((namePart) => namePart?.trim())
    .filter(Boolean)
    .join(' ');

  return composed || null;
};
